module.exports = __webpack_public_path__ + "img/portfolio-letter.35e577e9.png";